/** Commentary is reading content until the owner has deliberately entered edit mode. */
export function commentarySettingsAvailable(editorMode: boolean, canConfigure: boolean): boolean {
  return editorMode && canConfigure;
}
